import "./ErrorMessage.css";

export default function ErrorMessage() {
  return (
    <section className="error">
      <p>No Search Results Yet! Please submit a search above!</p>
    </section>
  );
}